// @ts-nocheck

import './leaflet-map.styles.css'

export const getMarkerIcon = (
  color: string,
  type?: 'cluster' | 'individual',
  count?: number,
) => {
  if (type === 'cluster') {
    return L.divIcon({
      html: `<div style="
        background-color: ${color};
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-weight: bold;
        border: 1px solid white;
      ">${count || ''}</div>`,
      className: 'custom-div-icon',
      iconSize: [40, 40],
      iconAnchor: [20, 20],
    })
  }

  // Individual marker SVG
  const svgMarker = `data:image/svg+xml,%3Csvg width="25" height="34" viewBox="0 0 24 30" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none"%3E%3Cpath d="M20.1318 20.7958L12 28.9275L3.86827 20.7958C-0.622761 16.3047 -0.622756 9.02337 3.86827 4.53234C8.3593 0.0413066 15.6406 0.0413008 20.1318 4.53234C24.6228 9.02336 24.6228 16.3047 20.1318 20.7958ZM12 15.8307C13.7489 15.8307 15.1667 14.413 15.1667 12.6641C15.1667 10.9152 13.7489 9.4974 12 9.4974C10.2511 9.4974 8.83333 10.9152 8.83333 12.6641C8.83333 14.413 10.2511 15.8307 12 15.8307Z" fill="${encodeURIComponent(color)}" stroke="%23333333"/%3E%3C/svg%3E`

  return L.icon({
    iconUrl: svgMarker,
    iconSize: [25, 34],
    iconAnchor: [12.5, 34],
    popupAnchor: [0, -34],
  })
}
